/*
 *  Author: DL
 *  Date: 2020-12-04 09:36:13
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-18 11:38:40
 *  LastEditors: DL
 *  Description: 按钮组
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useState, useLayoutEffect, useRef } from 'react';
import classnames from 'classnames';
import { Icon } from 'ui';
import styles from './index.less';

export default function(props) {
    const { data, onClick, active, maxCount, value } = props;
    const [bttnValue, setBttnValue] = useState(-1);
    const [groupsHeight, setGroupsHeight] = useState(0);
    const [scrollTop, setScrollTop] = useState(0);
    const [scrollHeight, setScrollHeight] = useState(0);
    const globalRef = useRef({ divId: `div${Math.trunc(Math.random() * 1000000000)}` });

    const handleClick = event => {
        event.persist();
        const target = event.currentTarget;

        const value = isNaN(target.dataset.value) ? target.dataset.value : parseInt(target.dataset.value);

        // 开启点击高亮模式
        if (active) {
            setBttnValue(value);
        }

        if (onClick) {
            onClick(value);
        }
    };

    const handleScroll = event => {
        const scrollTop = Math.ceil(event.target.scrollTop);
        setScrollTop(scrollTop);
    };

    useLayoutEffect(() => {
        if (maxCount) {
            const { divId } = globalRef.current;
            if (document.querySelector(`#${divId}>div`)) {
                const btn = document.querySelector(`#${divId}>div`);
                const btnHeight = parseFloat(window.getComputedStyle(btn).height);
                const groupsHeight = Math.ceil(btnHeight * maxCount);
                const scrollHeight = document.querySelector(`#${divId}`).scrollHeight;

                setGroupsHeight(groupsHeight);
                setScrollHeight(scrollHeight);

                document.querySelector(`#${divId}`).style.height = `${groupsHeight}px`;
                document.querySelector(`#${divId}`).addEventListener('scroll', handleScroll);

                return () => document.querySelector(`#${divId}`).removeEventListener('scroll', handleScroll);
            }
        }
    }, [maxCount, data]);

    useLayoutEffect(() => {
        if (value !== undefined && data && data.length > 0) {
            const { divId } = globalRef.current;
            if (document.querySelector(`#${divId}>div`)) {
                const btn = document.querySelector(`#${divId}>div`);
                const btnHeight = parseFloat(window.getComputedStyle(btn).height);
                const groupsHeight = btnHeight * maxCount;
                const clientTop = Math.ceil((Math.abs(value - 1 - data.length) / maxCount - 1) * groupsHeight);
                document.querySelector(`#${divId}`).scrollTop = clientTop;
            }
        }
    }, [value, data, maxCount]);

    const arrowTop = classnames({
        iconjt01: true,
        [`${styles.disable}`]: scrollTop === 0,
    });

    const arrowDown = classnames({
        iconjtou02: true,
        [`${styles.disable}`]: groupsHeight + scrollTop >= scrollHeight,
    });

    return (
        <div className={styles.wrapper}>
            {maxCount ? (
                <button className={classnames([styles.bttn, styles.arrow])}>
                    <Icon className={arrowTop} />
                </button>
            ) : null}
            <div id={globalRef.current.divId} className={classnames([styles.groups, maxCount ? styles.scroll : ''])}>
                {data.map(item => {
                    const activeValue = value || bttnValue;
                    const activeClassName = classnames({
                        [`${styles.bttn}`]: true,
                        [`${styles.active}`]: item.value === activeValue,
                    });
                    return (
                        <div onClick={handleClick} key={item.value} data-value={item.value} className={activeClassName}>
                            {item.text}
                        </div>
                    );
                })}
            </div>
            {maxCount ? (
                <button className={classnames([styles.bttn, styles.arrow])}>
                    <Icon className={arrowDown} />
                </button>
            ) : null}
        </div>
    );
}
